import React from 'react';
export function IntroSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 space-y-4 text-gray-700 text-lg leading-relaxed" data-id="element-1551">
      <p data-id="element-1552">
        If you've spent some time reading around the cutting videos, then you'll
        know that fiber lasers aren't the only type of laser on the market. The
        other two main types of laser are{' '}
        <a href="https://en.wikipedia.org/wiki/Gas_laser" target="_blank" rel="noopener noreferrer" className="text-orange hover:underline font-bold" data-id="element-1553">
          gas lasers
        </a>
        , which mostly use carbon dioxide (CO2), but also occasionally
        helium-neon, and crystal lasers, which uses neodymium-doped yttrium
        aluminum garnet.
      </p>
      <p data-id="element-1554">
        As gas lasers, and CO2 lasers in particular, are the most commonly used
        lasers on the market, we thought it would be useful to have a{' '}
        <a href="http://www.industrial-lasers.com/articles/2013/11/fiber-versus-co2-laser-cutting.html" target="_blank" rel="noopener noreferrer" className="text-orange hover:underline font-bold" data-id="element-1555">
          comparison of fiber lasers vs CO2 lasers
        </a>
        . You can find more on that below.
      </p>
    </div>;
}